import React from "react";
import "./travel.css"

function Travel(){
    return(
        <div className="card">
            <nav className="card-title">
                <h3 className="card-title-text">My Travel Journey in Melbourne</h3>
            </nav>
            
        </div>
    )
}

export default Travel